/**
 * KpiCard — tile reusable para KPIs del dashboard.
 *
 * Per FWA-PWA-032 G0 D3. Pattern similar a OutboxView count tiles.
 */

type Tone = 'blue' | 'green' | 'amber' | 'red' | 'gray';

interface KpiCardProps {
  label: string;
  value: number | string;
  tone: Tone;
  hint?: string;
}

const TONE_CLASSES: Record<Tone, string> = {
  blue: 'bg-blue-50 text-blue-800 border-blue-200',
  green: 'bg-green-50 text-green-800 border-green-200',
  amber: 'bg-amber-50 text-amber-800 border-amber-200',
  red: 'bg-red-50 text-red-800 border-red-200',
  gray: 'bg-gray-50 text-gray-800 border-gray-200',
};

export function KpiCard({ label, value, tone, hint }: KpiCardProps) {
  return (
    <div className={`p-4 rounded-md border ${TONE_CLASSES[tone]}`}>
      <div className="text-xs uppercase tracking-wide opacity-80">{label}</div>
      <div className="text-3xl font-semibold mt-1">{value}</div>
      {hint && <div className="text-xs mt-1 opacity-70">{hint}</div>}
    </div>
  );
}
